var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "j-toast",
      class: { "show-j-toast": _vm.showToast, "hide-j-toast": !_vm.showToast }
    },
    [
      _c("div", { class: "j-toast__line-left " + _vm.type + " m__r--10" }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("@/assets/icon/toast/" + _vm.type + ".svg"),
          width: "23"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "j-toast__wrap" }, [
        _c("div", { staticClass: "j-toast__title" }, [
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "j-toast__content" }, [
          _vm._v(_vm._s(_vm.content))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "j-toast__close",
          on: {
            click: function($event) {
              _vm.showToast = false
            }
          }
        },
        [_vm._v("x")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fe7c356", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe7c356","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast/jToast.vue
// module id = null
// module chunks = 